<ion-list [formGroup]="parent">
  <ion-label class="bepatient-question-title">{{ question.label }}</ion-label>
  <ion-item [ngSwitch]="question.dualKnobs">
    <ion-range
      *ngSwitchDefault
      [id]="question.key"
      [min]="question.min"
      [max]="question.max"
      [step]="question.step"
      [color]="question.color"
      [name]="question.key"
      [attr.disabled]="question.disabled || question.readonly"
      [formControlName]="question.key"
    >
      <ion-label slot="start">{{ question.min }}</ion-label>
      <ion-label slot="end">{{ question.max }}</ion-label>
    </ion-range>
    <ion-range
      *ngSwitchCase="true"
      [id]="question.key"
      [min]="question.min"
      [max]="question.max"
      [step]="question.step"
      [color]="question.color"
      [name]="question.key"
      [attr.disabled]="question.disabled || question.readonly"
      [formControlName]="question.key"
      dualKnobs="true"
    >
      <ion-label class="bepatient__range_label" slot="start">{{
        parent.value[question.key]['lower']
      }}</ion-label>
      <ion-label class="bepatient__range_label" slot="end">{{
        parent.value[question.key]['upper']
      }}</ion-label>
    </ion-range>
  </ion-item>
</ion-list>
